import React from 'react';
import style from './Connecting.module.css';

function ConnectingPage() {
	return (<div className={style.ConnectingWrapper}><div>Connecting to Server</div></div>);
}

export default ConnectingPage;